<div style="display: block; text-align: center; padding-top: 3px">
    <label
        class="sc-pf-text"
        style="margin-bottom: 0"
        >{{ text }}</label
    >
    <label class="switch">
        <input
            type="checkbox"
            [ngModel]="isSelected"
            (ngModelChange)="_onToggleIsSelected($event)"
            [disabled]="!canBeToggled"
        />
        <span
            class="slider round"
            [attr.cmps-sc-is-selected]="isSelected"
            [attr.cmps-sc-can-be-toggled]="canBeToggled"
        ></span>
    </label>
</div>
